import { render, staticRenderFns } from "./ReceiveCodeModal.vue?vue&type=template&id=a5a1c656"
import script from "./ReceiveCodeModal.vue?vue&type=script&lang=js"
export * from "./ReceiveCodeModal.vue?vue&type=script&lang=js"
import style0 from "./ReceiveCodeModal.vue?vue&type=style&index=0&id=a5a1c656&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports